export default __webpack_public_path__ + "static/media/scene_09.d19344a1.mp3";